import { visitorCatalogCtaMarkup } from '../../visitorCatalogCta';

/**
 * Home discovery, recommendation, and flywheel markup. Runtime data mounts:
 *
 *   1. Topic Trending              — /api/topics/trending
 *      mount point: #homeTopicTrendingRail
 *
 *   2. New                        — /api/topics/newest
 *      mount point: #homeTopicNewestRail
 *
 *   3. Community flywheel card     — single highest-voted in-progress idea
 *      source: /api/community/ideas?status=inprogress&limit=1
 *      mount point: #flywheelCard
 *
 * The flywheel-steps and other static copy (section header text, AI
 * workbench text, "Recommended for you" header) stay here because
 * they are product copy, not business data.
 */
export const homeRecommendationSectionsMarkup = String.raw`<section class="sv-section recommended-section home-discovery-section" id="featuredSection" aria-busy="false">
        <div class="sv-section-header">
          <div>
            <h3 id="homeRecommendedHeading">Explore more topics</h3>
          </div>
          <div class="rec-header-actions">
            <a href="/browse" data-proto-click="navigateToBrowse('recommended');return false;">See all</a>
          </div>
        </div>
        <div class="topic-grid home-recommendation-grid home-discovery-grid home-mobile-poster-surface" id="recommended-list">
          <div class="topic-card-skeleton" aria-hidden="true"></div>
          <div class="topic-card-skeleton" aria-hidden="true"></div>
          <div class="topic-card-skeleton" aria-hidden="true"></div>
          <div class="topic-card-skeleton" aria-hidden="true"></div>
        </div>
        <p id="homeRecommendedLive" class="home-recommendation-live" aria-live="polite" aria-atomic="true"></p>
        <div id="homeVisitorCatalogCta" style="display:none;">${visitorCatalogCtaMarkup('home', 'visitor-catalog-cta--home')}</div>
      </section><section class="sv-section free-guest-home home-guest-contexts" id="multimodalSection">
        <div class="sv-section-header">
          <div>
            <h3>One topic, three contexts</h3>
          </div>
        </div>
        <div class="mode-strip home-guest-contexts-desktop" role="list" aria-label="Three ways to use one topic">
          <div class="mode-card" role="listitem">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z"></path></svg>
            <h4>Read at desk</h4>
            <p>Scan the outline, inspect diagrams, and build the mental model while you work.</p>
          </div>
          <div class="mode-card" role="listitem">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1v-8h3zM3 19a2 2 0 0 0 2 2h1v-8H3z"></path></svg>
            <h4>Listen in motion</h4>
            <p>Continue the same chapter as clean audio during transit, gym time, or low-focus moments.</p>
          </div>
          <div class="mode-card" role="listitem">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polygon points="10 9 15 12 10 15 10 9"></polygon></svg>
            <h4>Watch for context</h4>
            <p>Switch to video when architecture, workflows, and examples need visual context.</p>
          </div>
        </div>
        <div class="home-guest-contexts-mobile" aria-label="Three ways to use one topic">
          <div class="home-guest-contexts-mobile-intro">
            <div>
              <h4>Learn wherever the day takes you</h4>
              <p>Read at your desk, listen on the move, or watch when visual context matters.</p>
            </div>
          </div>
          <div class="home-guest-contexts-mobile-modes" role="list">
            <span role="listitem"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z"></path></svg><strong>Read</strong></span>
            <span role="listitem"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1v-8h3zM3 19a2 2 0 0 0 2 2h1v-8H3z"></path></svg><strong>Listen</strong></span>
            <span role="listitem"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polygon points="10 9 15 12 10 15 10 9"></polygon></svg><strong>Watch</strong></span>
          </div>
        </div>
      </section><section class="sv-section trending-section home-discovery-section" id="trendingSection"><div class="sv-section-header" id="trendingHeaderSection">
        <div>
		  <h2 class="home-discovery-section-title" style="display:inline-flex;align-items:center;gap:8px;">
			Trending topics
		  </h2>
        </div>
        <a href="/browse?category=all&amp;sort=trending" data-proto-click="navigateToBrowse('all', 'trending');return false;">View all</a>
      </div><div class="scroll-list trending-list home-discovery-rail home-mobile-poster-surface" id="homeTopicTrendingRail" data-mobile-topic-layout="snap">
        <div class="home-topic-skeleton" aria-hidden="true"></div>
        <div class="home-topic-skeleton" aria-hidden="true"></div>
        <div class="home-topic-skeleton" aria-hidden="true"></div>
        <div class="home-topic-skeleton" aria-hidden="true"></div>
        <div class="home-topic-skeleton" aria-hidden="true"></div>
      </div></section><section class="sv-section trending-section home-discovery-section" id="newestSection"><div class="sv-section-header">
        <div>
		  <h2 class="home-discovery-section-title">New topics</h2>
        </div>
        <a href="/browse?category=all&amp;sort=newest" data-proto-click="navigateToBrowse('all', 'newest');return false;">View all</a>
      </div><div class="scroll-list trending-list home-discovery-rail" id="homeTopicNewestRail" data-mobile-topic-layout="snap" data-layout-state="loading">
        <div class="home-new-library-group">
          <div class="home-topic-skeleton home-new-skeleton" aria-hidden="true"></div>
          <div class="home-topic-skeleton home-new-skeleton" aria-hidden="true"></div>
          <div class="home-topic-skeleton home-new-skeleton" aria-hidden="true"></div>
        </div>
        <div class="home-new-library-group">
          <div class="home-topic-skeleton home-new-skeleton" aria-hidden="true"></div>
          <div class="home-topic-skeleton home-new-skeleton" aria-hidden="true"></div>
          <div class="home-topic-skeleton home-new-skeleton" aria-hidden="true"></div>
        </div>
      </div></section>
      <section class="home-mobile-discovery-section" id="mobileHomeDiscoverySection" aria-label="Discover topics">
        <div class="home-mobile-section-header">
          <div class="home-mobile-text-tabs" role="tablist" aria-label="Discover topics">
            <button type="button" role="tab" id="mobileForYouTab" aria-controls="mobileForYouPanel" aria-selected="true">For you</button>
            <button type="button" role="tab" id="mobileTrendingTab" aria-controls="mobileTrendingPanel" aria-selected="false">Trending</button>
          </div>
          <a class="home-mobile-view-all" id="mobileForYouViewAll" href="/browse" data-proto-click="navigateToBrowse('recommended');return false;">View all</a>
          <a class="home-mobile-view-all" id="mobileTrendingViewAll" href="/browse?category=all&amp;sort=trending" data-proto-click="navigateToBrowse('all', 'trending');return false;" hidden>View all</a>
        </div>
        <div id="mobileForYouPanel" class="home-mobile-topic-feed" role="tabpanel" aria-labelledby="mobileForYouTab"></div>
        <div id="mobileTrendingPanel" class="home-mobile-topic-feed" role="tabpanel" aria-labelledby="mobileTrendingTab" hidden><div id="mobileTrendingFeed" class="topic-grid home-recommendation-grid home-mobile-poster-surface home-mobile-topic-feed-list"></div></div>
      </section><section class="sv-section home-guest-community" id="communitySection">
        <div class="sv-section-header">
          <div>
            <h3>What the community wants next</h3>
          </div>
          <a href="/community" data-proto-click="showView('community');setActiveTab('community');return false;">Open community</a>
        </div>
        <div class="flywheel-panel home-guest-flywheel-panel home-guest-community-desktop">
          <div class="flywheel-steps home-guest-flywheel-steps" aria-label="How a community pick becomes a topic">
            <div class="flywheel-step"><span class="flywheel-step-num">01</span><strong>Requested</strong><span>DeepMox curates the topics worth building next.</span></div>
            <div class="flywheel-step"><span class="flywheel-step-num">02</span><strong>Supported</strong><span>The community supports what is worth producing next.</span></div>
              <div class="flywheel-step"><span class="flywheel-step-num">03</span><strong>In production</strong><span>DeepMox selects the most supported picks for production.</span></div>
            <div class="flywheel-step"><span class="flywheel-step-num">04</span><strong>Published</strong><span>Completed topics enter Browse, Home, and free previews.</span></div>
          </div>
          <div id="flywheelCard">
            <div class="home-flywheel-skeleton" aria-hidden="true"></div>
          </div>
        </div>
        <div class="home-guest-community-mobile" aria-live="polite">
          <div id="flywheelMobileCard"><div class="home-flywheel-skeleton" aria-hidden="true"></div></div>
        </div>
      </section>
    `;
